import { PageHeader } from "../components/PageHeader";
import { Clips } from "../components/Clips";

export const ClipsPage = () => {
    return (
        <div data-testid="clips-page">
            <PageHeader
                eyebrow="Highlights"
                title="The chaos,"
                accent="bottled."
                intro="A rolling collection of the moments worth replaying. Real clips swap in as the streams keep cooking — pull up live to make the next one."
                breadcrumbs={[{ label: "Home", href: "/" }, { label: "Clips" }]}
            />
            <Clips />
        </div>
    );
};
